import View from './view';
import Edit from './edit';

export default View;
export { View, Edit };